
import "/vercel/path0/src/App.module.less?modules";
export default {"videoPreview": `videoPreview-Nb77pGlf`,"gridItem": `gridItem-1zFckePR`,"imgPreview": `imgPreview-WSB3eSKA`,"logoWrp": `logoWrp-FBmNTG9z`,"grid": `grid-Rx3H0p0J`,"thumbnail": `thumbnail-jSPveEJ-`,"logo": `logo-rceDH5L5`,"modalWrp": `modalWrp-GJS1iefs`,"pwdWrp": `pwdWrp-DeJJasqN`,"imgPlaceholder": `imgPlaceholder-T3aszCPB`}
